import { useAuth } from 'react-oidc-context';
import { Link } from 'react-router-dom';
import { useOrganization } from '../contexts/OrganizationContext';
import { useAdmin } from '../contexts/AdminContext';
import casetrailLogo from '../assets/casetrail_favicon_transparent.png';

function Navbar() {
  const auth = useAuth();
  const { organization } = useOrganization();
  const { isAdmin, isSuperAdmin, isAttorney } = useAdmin();

  const signOutRedirect = () => {
    // Simple "soft logout" - clears local session and redirects to home
    // Note: User will still have an active Cognito session (SSO), but app treats them as logged out
    auth.removeUser();
    window.location.href = '/';
  };
  return (
    <nav className="navbar navbar-expand-lg navbar-dark bg-dark">
      <div className="container">
        <Link className="navbar-brand d-flex align-items-center" to="/">
          <img 
            src={casetrailLogo} 
            alt="Case Trail" 
            height="32" 
            className="navbar-logo me-2"
          />
          <span className="navbar-brand-text">Case Trail</span>
        </Link>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav">
            {auth.isAuthenticated && (
              <>
                {/* Attorney-specific navigation */}
                {isAttorney && (
                  <li className="nav-item">
                    <Link className="nav-link" to="/attorney">
                      <i className="bi bi-briefcase me-1"></i>
                      My Cases
                    </Link>
                  </li>
                )}
                
                {/* Regular user navigation (hidden for attorneys) */}
                {!isAttorney && (
                  <>
                    <li className="nav-item">
                      <Link className="nav-link" to="/cases">List Cases</Link>
                    </li>
                    <li className="nav-item">
                      <Link className="nav-link" to="/create-case">Create Case</Link>
                    </li>
                  </>
                )}
                
                {/* Admin menu (only for admins, never for attorneys) */}
                {isAdmin && !isAttorney && (
                  <li className="nav-item dropdown">
                    <a 
                      className="nav-link dropdown-toggle" 
                      href="#" 
                      id="adminDropdown" 
                      role="button" 
                      data-bs-toggle="dropdown" 
                      aria-expanded="false"
                    >
                      <i className="bi bi-shield-lock me-1"></i>
                      Admin
                    </a>
                    <ul className="dropdown-menu" aria-labelledby="adminDropdown">
                      <li>
                        <Link className="dropdown-item" to="/admin/organizations">
                          <i className="bi bi-building me-2"></i>
                          Organizations
                        </Link>
                      </li>
                      <li>
                        <Link className="dropdown-item" to="/admin/users">
                          <i className="bi bi-people me-2"></i>
                          Users
                        </Link>
                      </li>
                      <li>
                        <Link className="dropdown-item" to="/admin/invoices">
                          <i className="bi bi-receipt me-2"></i>
                          Invoices
                        </Link>
                      </li>
                      {isSuperAdmin && (
                        <li>
                          <Link className="dropdown-item" to="/admin/benchmarks">
                            <i className="bi bi-speedometer2 me-2"></i>
                            Benchmarks
                          </Link>
                        </li>
                      )}
                    </ul>
                  </li>
                )}
              </>
            )}
          </ul>
          <ul className="navbar-nav ms-auto">
            {auth.isAuthenticated && isAttorney && (
              <li className="nav-item">
                <span className="nav-link">
                  <span className="badge bg-info">
                    <i className="bi bi-person-badge me-1"></i>
                    Attorney
                  </span>
                </span>
              </li>
            )}
            {auth.isAuthenticated && organization && (
              <li className="nav-item">
                <span className="nav-link text-light" style={{ paddingTop: '0', paddingBottom: '0' }}>
                  <div>
                    <div>
                      <i className="bi bi-building me-1"></i>
                      {organization.organization_name}
                    </div>
                    {auth.user?.profile?.email && (
                      <div className="text-white-50" style={{ fontSize: '0.75rem', marginTop: '-2px' }}>
                        <i className="bi bi-person-circle me-1"></i>
                        {auth.user.profile.email}
                      </div>
                    )}
                  </div>
                </span>
              </li>
            )}
            <li className="nav-item">
              {auth.isAuthenticated ? 
                <Link className="nav-link" to="#" onClick={() => signOutRedirect()}>Sign out</Link> : 
                <Link className="nav-link" to="#" onClick={() => auth.signinRedirect()}>Sign in</Link>}
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;